<template>
  <div class="card-viaje mb-10">
    <div class="imagen-viaje">
      <img :src="getExperienceImage()" class="imagen" alt="Trip Image" />
    </div>
    <div class="p-15">
      <div class="fw-semibold fs-19 mb-10 text-primary">{{ viaje.nombre }}</div>
      <div class="d-flex align-items-center mb-2">
        <CustomIcon :icon="locationIcon" class="me-2 text-primary" />
        <span class="fs-16 text-primary">{{ viaje.lugarExperiencia?.nombre }}</span>
      </div>
      <div class="d-flex align-items-center">
        <CustomIcon :icon="calendaryIcon" class="me-2 text-primary" />
        <span class="fs-16 text-primary">
          {{ formatDateDDmmm(viaje.fechaInicio) }}
          <template v-if="viaje.fechaInicio !== viaje.fechaFin"> - {{ formatDateDDmmm(viaje.fechaFin) }}</template>
        </span>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { computed } from 'vue';
  import CustomIcon from '@/components/CustomIcon.vue';
  import calendaryIcon from '@/assets/icons/calendar.svg';
  import locationIcon from '@/assets/icons/ubicacion.svg';
  import { informacionHabitacion } from '@/store_pinia/informacionHabitacion';
  import { agenciaStoreModule } from '@/store_pinia/agencia';
  import { formatDateDDmmm } from '@/helpers/dateUtiles';

  const storeHabitacion = informacionHabitacion();
  const agenciaStore = agenciaStoreModule();

  const viaje = computed(() => storeHabitacion.getViaje);

  function getExperienceImage() {
    return viaje.value.imagenExperiencia || agenciaStore.getImagenFondo;
  }
</script>

<style lang="scss" scoped>
  .card-viaje {
    border-radius: var(--bs-border-radius-xl);
    border: 1px solid rgba(var(--bs-primary-rgb), 0.2);
    overflow: hidden;
    background: white;

    .imagen-viaje {
      height: 130px;
      overflow: hidden;

      .imagen {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
</style>
